import React from "react";
import { Camera } from "lucide-react";

const RecentJobs = ({ language }) => {
  const content = {
    es: {
      title: "Trabajos recientes",
      subtitle: "Fotos pronto",
      description: "Pronto añadiré fotos de mis trabajos en Valencia",
    },
    en: {
      title: "Recent jobs",
      subtitle: "Photos coming soon",
      description: "Photos of my work in Valencia coming soon",
    },
  };

  const currentContent = content[language];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {currentContent.title}
          </h2>
          
          {/* Coming Soon Message */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 sm:p-16">
            <div className="flex flex-col items-center">
              <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mb-6">
                <Camera className="w-10 h-10 text-[#2563EB]" />
              </div>
              <p className="text-xl sm:text-2xl font-semibold text-[#2563EB] mb-3">
                {currentContent.subtitle}
              </p>
              <p className="text-gray-600 text-center">
                {currentContent.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecentJobs;
